import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@cinch-labs/design-system";
import cx from "classnames";
import React from "react";
import styles from "./carousel-navigation.module.css";
const CarouselNavigation = ({ customClassNames , buttonIcons ={
    leftIcon: "chevron-left",
    rightIcon: "chevron-right"
} , ariaLabels , name  })=>{
    const wrapperClassNames = cx(styles.controls, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.wrapper);
    const prevBtnClassNames = cx(`${name}-prev`, styles.controlsBtn, styles.controlsBtnPrev, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.prevButton);
    const nextBtnClassNames = cx(`${name}-next`, styles.controlsBtn, styles.controlsBtnNext, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.nextButton);
    return /*#__PURE__*/ _jsxs("div", {
        "data-slide-controls": true,
        className: wrapperClassNames,
        "data-testid": "ds-carousel-controls",
        children: [
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: prevBtnClassNames,
                "aria-label": ariaLabels.previous,
                children: /*#__PURE__*/ _jsx(SvgIcon, {
                    name: buttonIcons.leftIcon,
                    size: 22
                })
            }),
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: nextBtnClassNames,
                "aria-label": ariaLabels.next,
                children: /*#__PURE__*/ _jsx(SvgIcon, {
                    name: buttonIcons.rightIcon,
                    size: 22
                })
            })
        ]
    });
};
export default CarouselNavigation;
